import React, { useState, useEffect } from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBContainer,
  MDBInputGroup,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import womencoffe from "../../img/womencoffe.png";
import womenOrange from "../../img/womenOrange.png";
import womanYellowBackground from "../../img/newImageNotPain.png"
import MobileHomepage from "../../img/homepage-390.png"
import BBISlim from "../../img/elana-slim-icons/incontinence-slim.png"
import BPSlim from "../../img/elana-slim-icons/bladder-pain-slim.png"
import ConstiSlim from "../../img/elana-slim-icons/constipation-slim.png"
import EndoSlim from "../../img/elana-slim-icons/endometriosis-slim.png"
import MenoSlim from "../../img/elana-slim-icons/menopause-slim.png"
import PSSlim from "../../img/elana-slim-icons/painful-sex-slim.png"
import PelvicProlSlim from "../../img/elana-slim-icons/prolapse-slim.png"
import PostPartSlim from "../../img/elana-slim-icons/postpartum-slim.png"
import ProactiveCareSlim from "../../img/elana-slim-icons/date-slim.png"
import SASlim from "../../img/elana-slim-icons/separated-abs-slim.png"
import VaginoPrepSlim from "../../img/elana-slim-icons/vaginoplasty-slim.png"

import { addEmailRecipient } from "../../features/emailCollection/emailCollectionSlice";
import { getPractitionerUsers } from "../../features/auth/authSlice";
import { getPractitionerProfiles } from "../../features/practitionerProfiles/practitionerProfileSlice";
import { getAllEmailRecipients } from "../../features/emailCollection/emailCollectionSlice";
import { useDispatch } from "react-redux";
import { NewFooter } from "../../components/newFooter";
import "../../styles/homepage.css";
import "../../styles/newIndividualPage.css";
import keyRi from "../../img/newKeyBoardArrow.png";

export const HomePage = () => {
  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  useEffect(() => {
    dispatch(getPractitionerUsers());
    dispatch(getPractitionerProfiles());
    dispatch(getAllEmailRecipients());
  }, []);

  const addEmailToNewsletterList = (email) => {
    dispatch(addEmailRecipient({ email: email, type: "Newsletter" }));
    setNewsletterEmail("");
  };

  return (
    <div>
      {/* Homepage Banner 1 - Main header with Picture */}

      {/* DESKTOP */}
      <div className="homepage-image text-center mobile-view-hidden">
        <div className="pt-5">
          <div className="pt-5">
            <h1 className="titlehomepage m-0 text-black">
              Your Partner in Pelvic Care
            </h1>
          </div>
          <div className="mb-2">
            <p className="parahomepage text-center m-0 text-dm text-black">
              Elana connects you to pelvic care, so you feel confident from the
              inside out.
            </p>
          </div>
        </div>
        <div>
          <Link to="/Individual">
            <button className="button-NewHome blue-hover m-4 me-5 border-0 text-dm">
              INDIVIDUALS
            </button>
          </Link>
          <Link to="/Practitioner">
            <button className="button-NewHome blue-hover m-4 border-0 text-dm">
              PRACTITIONERS
            </button>
          </Link>
        </div>
      </div>

      {/* MOBILE */}
      <div className="homepage-banner-1 d-flex align-items-center ">
        <MDBRow className="desktop-view-hidden">
          <MDBCol
            className="d-flex align-items-center justify-content-end"
            md="6"
          >
            <div className="pt-3 bg-white">
              <h1 className="homepage-banner-1-mobile-padding text-position banner-1-h1 text-black padding-top-mobile">
                Your Partner
                <br /> in Pelvic Care
              </h1>
              <h5 className="homepage-banner-1-mobile-padding pb-3 text-position text-dm text-thin banner-1-h3 text-spacing-minus-1 mt-2 text-black">
                Elana connects you to pelvic care options,
                <br className="mobile-view-hidden" /> so you feel confident from
                the inside out.
              </h5>
              <div className="homepage-banner-1-mobile-padding mt-3">
                <div className="d-flex justify-content-center w-100">
                  <Link to="/Individual">
                    <button className="brand-bg-purple border-0 py-2 blue-hover text-dm homepage-cards-button w-100 homepage-button-mobile homepage-individual-button-mobile">
                      INDIVIDUALS
                    </button>
                  </Link>
                </div>
                <div className="d-flex justify-content-center w-100 mt-3">
                  <Link to="/Practitioner">
                    <button className="brand-bg-purple border-0 mt-4 py-2 blue-hover text-dm homepage-cards-button w-100 homepage-button-mobile homepage-practitioner-button-mobile">
                      PRACTITIONERS
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </MDBCol>
          <MDBCol md="6">
            <div className="img-fit-2">
              <img
                className="img-fit-2 bg-white"
                src={MobileHomepage}
                alt="women-smiling"
              />
            </div>
          </MDBCol>
        </MDBRow>
      </div>

      {/* Homepage Banner 3 - Card Carousel */}
      <div className="homepage-banner-3 banner-padding">
        <h1 className="text-center text-al fs-48-32 text-black">
          Embrace your Pelvic Power
        </h1>
        <h3 className="text-center text-dm fs-24-18 p-4 fw-lighter text-black text-spacing-minus-1 ">
        Elana makes it easy to find the right pelvic health treatment by connecting you to a wide variety<br className="mobile-view-hidden"/>{" "}of health practitioners and resources.
          We're your partner in pelvic
          care.
        </h3>
        <div className="d-flex justify-content-center align-items-center pb-4 mt-4">
          <a
            href="https://www.myelana.com/post/what-is-pelvic-health"
            target="_blank"
            rel="noreferrer"
            className="homepage-cards-button border-0 text-center text-dm text-spacing-minus-1 px-5 blue-hover"
          >
            WHAT IS PELVIC HEALTH?
          </a>
        </div>
        <div className="category-cards">
          <div className="carousel" id="slider">
            <div className="inner-carousel">
              <Link className="link-categories" to="/practitionerListing/0">
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Bladder & Bowel Incontinence
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={BBISlim} />
                  </div>
                </div>
              </Link>
              <Link
                className="link-categories d-flex justify-content-center"
                to="/practitionerListing/1"
              >
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Bladder Pain
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={BPSlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/2">
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Constipation
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={ConstiSlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/3">
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Endometriosis
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={EndoSlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/4">
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Menopause & Perimenopause
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={MenoSlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/5">
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Painful Sex
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={PSSlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/6">
                <div className="item mx-5 pb-2 pt-2">
                  <h6 className="text-center text-al mt-3 text-black fs-24">
                    Pelvic Organ Prolapse
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={PelvicProlSlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/7">
                <div className="item mx-5 pb-2 pt-2">
                  <h6 className="text-center text-al mt-3 text-black fs-24">
                    Postpartum Recovery
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={PostPartSlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/8">
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Proactive Pelvic Care
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={ProactiveCareSlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/9">
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Separated Abs
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={SASlim} />
                  </div>
                </div>
              </Link>
              <Link className="link-categories" to="/practitionerListing/10">
                <div className="item mx-5 pb-2 pt-3">
                  <h6 className="text-center text-al mt-2 text-black fs-24">
                    Vaginoplasty Prep & Recovery
                  </h6>
                  <div className="d-flex justify-content-center mt-3">
                    <img src={VaginoPrepSlim} />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Homepage Banner 4 - Title and Statistics */}
      <div className="homepage-banner-4 banner-padding">
        <h1 className="banner-2-h1 px-1 text-center text-black">
          Pelvic issues are way more
          <br className="desktop-view-hidden" /> common than you think.
        </h1>
        <div className="info-banner-padding">
          <MDBRow className="px-4">
            <MDBCol
              className="info-border-1 info-vertical-margin"
              size="12"
              md="6"
              lg="3"
            >
              <div className="text-center px-5 py-4">
                <p className="m-0 text-al fs-48-28 text-purple align-text-bottom">
                  1 in 6
                </p>
                <p className="m-0 fs-16 text-black text-dm text-spacing-minus-1">
                  women suffer from
                  <br />
                  painful sex
                </p>
              </div>
            </MDBCol>

            <div className="purple-divider m-auto"></div>

            <MDBCol
              className="info-border-2 info-vertical-margin"
              size="12"
              md="6"
              lg="3"
            >
              <div className="text-center px-5 py-4">
                <p className="m-0 text-al fs-48-28 text-purple">1 in 3</p>
                <p className="m-0 fs-16 text-black text-dm text-spacing-minus-1">
                  women experience
                  <br />
                  urinary incontinence
                </p>
              </div>
            </MDBCol>

            <div className="purple-divider m-auto"></div>

            <MDBCol
              className="info-border-3 info-vertical-margin"
              size="12"
              md="6"
              lg="3"
            >
              <div className="text-center px-5 py-4 ">
                <p className="m-0 text-al fs-48-28 text-purple">50%</p>
                <p className="m-0 fs-16 text-black text-dm whitespace text-spacing-minus-1">
                  postmenopausal
                  <br className="desktop-view-hidden" /> women
                  <br className="mobile-view-hidden" /> have
                  <br className="desktop-view-hidden" /> vaginal atrophy
                </p>
              </div>
            </MDBCol>

            <div className="purple-divider m-auto"></div>

            <MDBCol
              className="info-border-4 info-vertical-margin"
              size="12"
              md="6"
              lg="3"
            >
              <div className="text-center px-5 py-4">
                <p className="m-0 text-al fs-48-28 text-purple">7 Years</p>
                <p className="m-0 fs-16 text-black text-dm text-spacing-minus-1">
                  average amount of
                  <br />
                  time to be diagnosed
                </p>
              </div>
            </MDBCol>
          </MDBRow>
        </div>
        <h3 className="pt-4 m-0 text-center fs-32 text-al mobile-view-hidden text-black">
          Pain is never normal. Many women suffer in silence.
        </h3>
      </div>

      {/* Homepage Banner 5 - Pelvic Care Updates */}
      <div className="homepage-banner-5 banner-padding">
        <div className="update-group-padding">
          <MDBRow>
            <MDBCol className="update-input-center" md="12" lg="7">
              <h1 className="text-al fs-48-32 m-0 text-black">
                Get Pelvic Care Updates
                <br className="desktop-view-hidden" /> from Elana
              </h1>
              <p className="m-0 mt-2 fs-24-18 text-dm text-black">
                Keep up to date on pelvic care
              </p>
            </MDBCol>
            <MDBCol md="12" lg="5">
              <div className="d-flex align-items-end h-100 update-input-center">
                <MDBInputGroup className="update-input-width mt-4 border-radius-8 text-dm">
                  <input
                    className="text-dm text-spacing-minus-1 border-radius-8 form-control update-input-padding"
                    placeholder="Enter your email"
                    type="text"
                    value={newsletterEmail}
                    onChange={(e) => {
                      setNewsletterEmail(e.target.value);
                    }}
                  />
                  <button
                    onClick={() => addEmailToNewsletterList(newsletterEmail)}
                    className="brand-bg-purple py-2 px-4 border-0 text-white blue-hover text-dm border-radius-end-8"
                  >
                    GET UPDATES
                  </button>
                </MDBInputGroup>
              </div>
            </MDBCol>
          </MDBRow>
        </div>
      </div>

      {/* Homepage Banner 6 - Coming Soon Infocircles */}
      <div className="homepage-banner-6 banner-padding">
        <div className="">
          <div className="pt-4">
            <h1 className="text-center fs-48-32 text-al text-black">
              Elana’s Personalized
              <br className="desktop-view-hidden" /> Approach to Care
            </h1>
            <h6 className="text-center text-coming-soon fs-24-18 text-dm mt-3">
              Coming soon
            </h6>
          </div>
          <div className="center-cricles mt-2">
            <div>
              <MDBContainer>
                <MDBRow className="center-mobile mt-2">
                  <MDBCol
                    size={windowDimensions.width <= 1000 ? "12" : ""}
                    className="d-flex justify-content-center mb-4"
                  >
                    <div className="circle-indivudial-two text-dm">
                      <h6>
                        Track your
                        <br /> Symptoms
                      </h6>
                    </div>
                  </MDBCol>
                  <MDBCol
                    size={windowDimensions.width <= 1000 ? "12" : ""}
                    className="d-flex justify-content-center mb-3"
                  >
                    <div className="circle-indivudial-two text-dm">
                      <h6>
                        Shopping for
                        <br /> Pelvic Health
                      </h6>
                    </div>
                  </MDBCol>
                  <MDBCol
                    size={windowDimensions.width <= 1000 ? "12" : ""}
                    className="d-flex justify-content-center mb-4"
                  >
                    <div className="circle-indivudial-two text-dm">
                      <h6>
                        Telehealth <br />
                        Services
                      </h6>
                    </div>
                  </MDBCol>
                  <MDBCol
                    size={windowDimensions.width <= 1000 ? "12" : ""}
                    className="d-flex justify-content-center mb-4"
                  >
                    <div className="circle-indivudial-two text-dm">
                      <h6>
                        Community <br />
                        Content
                      </h6>
                    </div>
                  </MDBCol>
                  {window.innerWidth > 992 && <MDBCol
                    size={windowDimensions.width <= 1000 ? "12" : ""}
                    className="d-flex justify-content-center mb-3 mobile-view-hidden"
                  >
                    <div className="circle-indivudial-two text-dm">
                      <h6>
                        Educational
                        <br /> Resources
                      </h6>
                    </div>
                  </MDBCol>}
                </MDBRow>
              </MDBContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Homepage Banner 7 - Contact the Team Info */}
      <div className="homepage-banner-7">
        <div
          className={
            windowDimensions.width <= 692
              ? "homepage-mobile-bubble"
              : "homepage-desktop-bubble"
          }
        >
          <div className="margin-row-controller container">
            <div className="text-controller-4 m-4 ">
              <div>
                <h1 className="text-separation text-al fs-48-32">
                  Check Out our Blogs on Pelvic Health
                </h1>
                <p className="text-separation text-dm text-coming-soon fs-24-18 mb-0">
                  Discover pelvic care with Elana
                </p>
              </div>
             <div className="read-all-spacing">
                <span className="text-separation">
                  <a
                    href="https://www.myelana.com/blog"
                    target="_blank"
                    className="text-decoration-none text-hover"
                  >
                    Read All
                  </a>
                  <span className="ms-2">
                    <img src={keyRi} className="text-hover arrow-icon-all" />
                  </span>
                </span>
              </div>
            </div>

            <div className="circlesController">
              {/* DESKTOP */}
              <div className="padding-row-controller blog-mobile-hidden">
                <MDBRow className="row-controller">
                  <MDBCol col="4" className="margin-cards">
                    <img src={womencoffe} className="card-blog-images"></img>
                    <p className="text-break separation-mobile fs-24-18 mt-2 text-dm">
                      Perimenopause: What it is and why it's not all bad.{" "}
                    </p>
                    <a
                      href="https://www.myelana.com/post/perimenopause-what-it-s-all-about-and-why-it-s-not-all-bad"
                      target="_blank"
                    >
                      <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                        READ MORE
                      </button>
                    </a>
                  </MDBCol>
                  <MDBCol col="4" className="margin-cards">
                    <img src={womenOrange} className="card-blog-images"></img>
                    <p className="text-break separation-mobile fs-24-18 mt-2 text-dm">
                      What is Pelvic Health? And where to find answers.
                    </p>
                    <a
                      href="https://www.myelana.com/post/what-is-pelvic-health"
                      target="_blank"
                    >
                      <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                        READ MORE
                      </button>
                    </a>
                  </MDBCol>
                  <MDBCol col="4" className="margin-cards">
                    <img src={womanYellowBackground} className="card-blog-images"></img>
                    <p className="separation-mobile fs-24-18 mt-2 text-dm">
                    It’s time to talk. Ending the taboo of pelvic health.

                    </p>
                    <a
                  target="_blank"
                  href="https://www.myelana.com/post/what-prevents-you-from-getting-help"
                >
                      <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                        READ MORE
                      </button>
                    </a>
                  </MDBCol>
                </MDBRow>
              </div>

              {/* MOBILE */}
              <div className="padding-row-controller blog-desktop-hidden">
                <MDBRow className="row-controller">
                  <MDBCol>
                    <a
                      className="link blue-hover"
                      href="https://www.myelana.com/post/perimenopause-what-it-s-all-about-and-why-it-s-not-all-bad"
                      target="_blank"
                    >
                      <div className="margin-cards">
                        <img
                          src={womencoffe}
                          className="card-blog-images"
                        ></img>
                        <p className="text-break separation-mobile fs-24-18-14 mt-2 text-dm text-black">
                          Perimenopause: What it is and why it's not all bad.{" "}
                        </p>
                        <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                          READ MORE
                        </button>
                      </div>
                    </a>
                  </MDBCol>
                  <MDBCol>
                    <a
                      className="link blue-hover"
                      href="https://www.myelana.com/post/what-is-pelvic-health"
                      target="_blank"
                    >
                      <div className="margin-cards">
                        <img
                          src={womenOrange}
                          className="card-blog-images"
                        ></img>
                        <p className="text-break separation-mobile fs-24-18-14 mt-2 text-dm text-black">
                          What is Pelvic Health? And where to find answers.
                        </p>
                        <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                          READ MORE
                        </button>
                      </div>
                    </a>
                  </MDBCol>
                  <MDBCol>
                    <a
                      className="link blue-hover"
                      href="https://www.myelana.com/post/your-guide-to-pelvic-wellness-start-caring-about-yourself-inside-out"
                      target="_blank"
                    >
                      <div className="margin-cards">
                        <img src={womanYellowBackground} className="card-blog-images"></img>
                        <p className="separation-mobile fs-24-18 mt-2 text-dm text-black">
                        It’s time to talk. Ending the taboo of pelvic health.

                        </p>
                        <button className="buttonEmail blue-hover no-phone mt-2 px-3 text-dm mb-2">
                          READ MORE
                        </button>
                      </div>
                    </a>
                  </MDBCol>
                </MDBRow>
              </div>
            </div>
          </div>
          <div className="homepage-cta-bottom">
            <h1 className="text-al text-black fs-48-28 mx-2">
              We’ll only send you the important stuff.
            </h1>
            <MDBRow>
              <MDBCol sm="12" md="6" className="d-flex ">
                <p className="m-0 text-dm text-gray fs-24-18 mx-2">
                  Sign up to get updates from Elana and the latest on pelvic
                  care delivered right to your inbox.
                </p>
              </MDBCol>
              <MDBCol
                sm="12"
                md="6"
                className="d-flex justify-content-center align-items-center"
              >
                <MDBInputGroup className="newsletter-input-width border-radius-8 text-dm input-homepage-cta">
                  <input
                    className="text-dm text-spacing-minus-1 border-radius-8 form-control update-input-padding"
                    placeholder="Enter your email"
                    type="text"
                    value={newsletterEmail}
                    onChange={(e) => {
                      setNewsletterEmail(e.target.value);
                    }}
                  />
                  <button
                    onClick={() => addEmailToNewsletterList(newsletterEmail)}
                    className="brand-bg-purple py-2 px-4 border-0 text-white blue-hover text-dm border-radius-end-8"
                  >
                    {windowDimensions.width > 450 ? "STAY IN THE KNOW" : "JOIN"}
                  </button>
                </MDBInputGroup>
              </MDBCol>
            </MDBRow>
            <p className="margin-disclaimer text-dm py-3 px-2 fs-12 text-gray">
              Disclaimer: The information provided through Elana Health website
              and services is not intended or implied to be a substitute for
              professional medical advice, diagnosis or treatment.
            </p>
          </div>
        </div>
      </div>
      <NewFooter />
    </div>
  );
};
